<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import couponForm from "./forms/coupon-form.vue";
import CustomTable from "@/components/tables/custom-table.vue";
import AddButton from "@/components/buttons/add-button.vue";
import Status from "@/helpers/general/status";


/**
 * Customers Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    AddButton,
    couponForm,
    CustomTable,
  },
  data() {
    return {
      formModalId:'coupon-form-modal',
      showModalId:'coupon-show-modal',
      pageHeader:{
        title: "Cupones",
        breadcrumbs: [
          {
            text: "Cupones",
            href: "/coupons",
            active: true
          }
        ],
      },
      coupon_discount_types: Status.getList('coupon_discount_types'),
      table:{
        url:'/coupons',
        params: {
        },
        fields:[
          { key: "id", label: "Id", sortable: true },
          { key: "code", label: "Código", sortable: true },
          { key: "discount_type", label: "Tipo de cupón", sortable: true },
          { key: "amount", label: "Importe del cupón", sortable: true },
          { key: "description", label: "Descripción", sortable: true },
          { key: "usage_limit", label: "Uso / Límite", sortable: false },
          { key: "date_expires", label: "Fecha de caducidad", sortable: false },
        ],
        formatted_fields:[
          'discount_type',
          'usage_limit'
        ]
      },
      formSelectedItemId:null,   
      showSelectedItemId:null,
      clone:false
    };
  },
  methods: {
    showEditModal(item, clone = false) {
      this.formSelectedItemId = item?.id || null;
      this.clone = clone;
      this.$bvModal.show(this.formModalId);
    },
    showViewModal(item) {
      this.showSelectedItemId = item?.id || null;
      this.$bvModal.show(this.showModalId);
    },
    onSuccess(){
      this.$refs.customerTable.refresh();
    },
    formatter(field, item){
      switch(field){
        case 'discount_type':
          return Status.getStatus({itemStatus: item?.discount_type, type: 'coupon_discount_types'});
        case 'usage_limit':
          return item?.usage_limit || '∞';
        default:
          return '';
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="pageHeader?.title" :items="pageHeader?.breadcrumbs" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <couponForm :modal-id="formModalId" :id="formSelectedItemId" @onSuccess="onSuccess" :clone="clone"></couponForm>
            <CustomTable
              :url="table.url"
              :fields="table.fields"
              :formatted-fields="table.formatted_fields"
              :formatter="formatter"
              :params="table.params"
              @edit="showEditModal"
              ref="customerTable"
              :show-view="false"
              :showSoftDelete="false"
              @show="showViewModal"
              :show-modal-id="showModalId"
            >
              <template v-slot:header-actions>
                <AddButton @click="showEditModal"></AddButton>
              </template>
              <template v-slot:filters="{ filters }">
                <div class="row">
                    <div class="form-group col-12 col-lg-4 col-sm-6">
                        <label for="code">Código</label>
                        <input id="code" v-model="filters.code" type="text" class="form-control" placeholder="Ingresa un Código para filtrar"/>
                    </div>
                    <div class="form-group col-12 col-lg-4 col-sm-6">
                        <label>Tipo de descuento</label>
                        <select v-model="filters.discount_type" class="form-control" placeholder="Todos">
                            <option value="">Todos</option>
                            <option v-for="option in coupon_discount_types" v-bind:value="option.id" :key="option.id">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>
                </div> 
              </template>
            </CustomTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>